import type { SiteName } from '@/scopes/common/domain/types'

const VOUCHER_URLS: Partial<Record<SiteName, string>> = {
  sunwebnl: '/mijn-sunweb/voucher-status-page',
  sunwebbenl: '/nl/mijn-sunweb/voucher-status-page',
  sunwebbefr: '/fr/mon-sunweb/voucher',
  sunwebde: '/mein-sunweb/voucher-status-page',
  sunwebdk: '/mit-sunweb/voucher',
  sunwebfr: '/mon-sunweb/voucher',
  sunwebse: '/mitt-sunweb/voucher-status-page',
  sunwebuk: '/my/voucher-status-page',
  elizanl: '/mijn-eliza/voucher',
  elizabe: '/mijn-eliza/voucher',
}

export function getVoucherUrl(siteName: SiteName, voucherCode: string): string | undefined {
  const baseUrl = VOUCHER_URLS[siteName]
  if (!baseUrl) {
    return undefined
  }

  return `${baseUrl}?voucher=${encodeURIComponent(voucherCode)}`
}
